module.exports = __webpack_public_path__ + "img/denmark.cdd4c11.webp";